const BASE_DELAY_MS = 1000
const MAX_DELAY_MS = 30_000

export function getReconnectDelay(
  retryCount: number,
  random: () => number = Math.random,
): number {
  const ceiling = Math.min(BASE_DELAY_MS * 2 ** retryCount, MAX_DELAY_MS)
  return Math.round(ceiling / 2 + random() * (ceiling / 2))
}
